const EmailCircle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={42} height={43} fill="none">
    <rect
      width={42}
      height={42}
      y={0.797}
      fill="var(--thankyou-verified-part-fill)"
      rx={21}
    />
    <path
      className="fill-(--thankyou-verified-part)"
      fillRule="evenodd"
      d="M14.208 27.612c-.039 0-.072-.02-.11-.023l4.883-4.902 1.628 1.67c.11.112.251.168.393.168a.552.552 0 0 0 .395-.169l1.626-1.669 4.88 4.903c-.036.003-.066.022-.105.022h-13.59Zm-1.01-.761a1.153 1.153 0 0 1-.072-.371v-9.366c0-.128.032-.245.069-.36l4.976 5.105-4.974 4.992Zm14.596-10.87c.043 0 .078.02.118.025l-6.914 7.1-6.919-7.099c.043-.006.08-.026.124-.026h13.59Zm1.077 1.133v9.366c0 .133-.033.257-.074.375l-4.974-4.996 4.977-5.11c.038.116.07.235.07.365Zm-1.076-2.317h-13.59c-1.216 0-2.205 1.04-2.205 2.317v9.366c0 1.277.99 2.317 2.205 2.317h13.59c1.216 0 2.205-1.04 2.205-2.317v-9.366c0-1.277-.99-2.317-2.205-2.317Z"
      clipRule="evenodd"
    />
  </svg>
)
export { EmailCircle }
